$(document).ready(function(){
    
  // Build a Box small print
  
  $("#bxp-bldr-price_total").append("<div class='bbsmallprint discountsmallprint'>Your applicable discount will be applied automatically at checkout.</div> ");
  $("#bxp-bldr-bottom-wizard").append("<div class='bbsmallprint'>* Once you proceed to the Cart, you will not be able to modify your selections.</div> ");

 
  $(".bxp-details-price").text(function(index, text) { 
    return text.replace(':', ' '); 
  });

  $("body").on('DOMSubtreeModified', "#bxp-bldr-total_value", function() {
      setTimeout(function(){  
        $(".bxp-details-price").text(function(index, text) { 
        return text.replace(':', ' '); 
        });
      }, 500);
  });

  /* setTimeout(function(){ 
      $(".rt-Box.rt-r-py-3.bb-details__info-popover.themeRight").append("<div class='bbsmallprint mobile'>Free shipping automatically added at checkout.</div> ");
      $(".rt-Flex.rt-r-fd-row.rt-r-jc-space-between.rt-r-gap-2").append("<div class='bbsmallprint desktop'>Free shipping automatically added at checkout.</div> ");
    }, 3000);
*/

});